

/**
 * @file mutations
 */

// 1.获取任务列表
export function SET_MENU_LIST(state, val) {
    state.menuList = val;
}

// 城市列表
export function SET_CITY_LIST(state, val) {
    state.cityList = val;
}

